import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { observeResource } from "kea-resource";

type Entity = models.PartidaAclaracionDTO;
import { columnas } from "./columns";
const resource = resources.PartidasAclaracion;
const observable = observeResource(resources.PartidasAclaracion.query);
export class PartidasAclaracionList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar partida en aclaracion?", x.Folio + " (" + kea.formatCurrency(x.Total) + ")" )) {
            await resource.delete(x.IdRegistro);
        }
    }

    onEdit = (x: Entity) => history.go("/operativa/partidasaclaracion/" + x.IdRegistro);
    onAgregar = () => history.go("/operativa/partidasaclaracion/new");
    onRegresar = () => history.go("/operativa");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Partidas en aclaración" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"partidasaclaracionListCookieKey"} items={observable} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/list/list.tsx